var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmLogoCroppedMirrored = function SvgSmLogoCroppedMirrored(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 424,
    viewBox: "0 0 434 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9403 178.868C24.2674 200.28 65.486 226.057 97.2025 244.42L374.529 412.504C406.695 433.338 453.532 421.717 474.269 390.932C475.039 389.774 475.568 388.473 475.824 387.107C476.08 385.74 476.057 384.336 475.757 382.978C475.457 381.62 474.887 380.337 474.08 379.205C473.272 378.073 472.245 377.116 471.059 376.39L78.4871 138.548L11.9403 178.868Z",
    fill: "url(#paint0_radial_418_7743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000881482 138.514C-0.0241371 152.844 4.13767 166.868 11.9732 178.866C163.911 86.7341 319.412 -7.58081 471.028 -99.4239C472.214 -100.15 473.241 -101.107 474.048 -102.239C474.856 -103.371 475.426 -104.655 475.726 -106.012C476.025 -107.37 476.048 -108.774 475.793 -110.141C475.537 -111.507 475.008 -112.808 474.238 -113.966C453.533 -144.655 406.632 -156.276 374.466 -135.442C378.318 -137.785 292.767 -85.9733 90.3334 36.7838C46.1936 63.685 0.0312277 85.2574 -0.000881482 138.514Z",
    fill: "url(#paint1_radial_418_7743)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M374.529 64.2662C333.504 64.2662 300.246 97.524 300.246 138.55C300.246 179.575 333.504 212.833 374.529 212.833C415.555 212.833 448.813 179.575 448.813 138.55C448.813 97.524 415.555 64.2662 374.529 64.2662Z",
    fill: "#7573FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_418_7743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.285 404.094) rotate(-180) scale(471.061 471.061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#413FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B428C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_418_7743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(509.037 39.5767) rotate(-180) scale(511.606 511.605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7573FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14BDEB"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmLogoCroppedMirrored);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sm-logo-cropped-mirrored.59c2381d539bb597ef86d9c0edc0db84.svg";